module.exports = __webpack_public_path__ + "img/lucky-chloe.88ea8c33.jpg";